import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

import UsersManagementHub from "./pages/users-management-hub";
import UsersCrudManagement from "./pages/users-crud-management";
import GalleryCrudMangment from "./pages/workshops-crud-management";
import BannerAdsCrudManagement from "./pages/banner-ads-crud-management";
import PushNotificationsCrudManagement from "./pages/push-notifications-crud-management";
import UserCarsProfileManagement from "./pages/user-cars-profile-management";
import AdminLoginAuthentication from "./pages/admin-login-authentication";
import WorkshopsAgenciesManagementHub from "./pages/workshops-agencies-management-hub";
import GovernoratesAreasHierarchicalManagement from "./pages/governorates-areas-hierarchical-management";
import GearTypeManagment from "pages/gear-cars-types-management";
import FuelTypeManagment from "pages/fuel-types-management";
import ColorsManagment from "pages/colors-managment";
import FavoritesManagment from "pages/favorites-management";
import CarTypeManagment from "pages/car-types-managment";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<AdminLoginAuthentication />} />
          <Route
            path="/users-management-hub"
            element={<UsersManagementHub />}
          />
          <Route
            path="/users-crud-management"
            element={<UsersCrudManagement />}
          />
          <Route path="/gallery" element={<GalleryCrudMangment />} />

          <Route
            path="/banner-ads-crud-management"
            element={<BannerAdsCrudManagement />}
          />
   
          <Route
            path="/notifications-management"
            element={<PushNotificationsCrudManagement />}
          />
          <Route
            path="/user-cars-profile-management"
            element={<UserCarsProfileManagement />}
          />
          <Route
            path="/gear-cars-types-management"
            element={<GearTypeManagment />}
          />
          <Route
            path="/car-type-management"
            element={<CarTypeManagment />}
          />
          
          <Route
            path="/fuel-types-management"
            element={<FuelTypeManagment />}
          />
          <Route path="/colors-management" element={<ColorsManagment />} />
          <Route
            path="/admin-login-authentication"
            element={<AdminLoginAuthentication />}
          />
          <Route
            path="/workshops-agencies-management-hub"
            element={<WorkshopsAgenciesManagementHub />}
          />
       
          <Route
            path="/governorates-areas-hierarchical-management"
            element={<GovernoratesAreasHierarchicalManagement />}
          />
          <Route
            path="/favorites-management"
            element={<FavoritesManagment />}
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
